export const Logo = ({ size = "md", className = "" }) => {
  const dims = { sm: "w-12 h-12", md: "w-14 h-14", lg: "w-44 h-44" }[size] || "w-14 h-14";
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo-white.png`}
      alt="THE MAD BAR"
      data-testid="madbar-logo"
      className={`${dims} object-contain ${className}`}
    />
  );
};
